import { render, staticRenderFns } from "./ViewUserDetails.vue?vue&type=template&id=40c109e9&"
import script from "./ViewUserDetails.vue?vue&type=script&lang=js&"
export * from "./ViewUserDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports